export default __webpack_public_path__ + "static/media/info-2.781e82a3.svg";